module.exports = __webpack_public_path__ + "img/bienvenida-inbi-2026.9156f2b8.jpg";